<template>
  <ul v-if="navList.length" class="navs-wrap flex-between">
    <li v-for="(item, index) in navList" :key="index">
      <AppItem v-if="item" :data="item"></AppItem>
    </li>
  </ul>
</template>

<script>
import AppItem from '@/components/AppItem'

export default {
  name: 'Info',
  components: { AppItem },
  data() {
    return {

    }
  },
  computed: {
    navList() {
      const list = this.$store.getters.currApps.ACD || []
      // 补余
      const index = list.length % 4
      if (index !== 0) {
        for (let i = 0; i < 4 - index; i++) {
          list.push('')
        }
      }
      console.log(list)
      return list
    }
  },
  mounted() {},
  methods: { }
}
</script>

<style lang="scss" scoped>

.navs-wrap {
  flex-wrap: wrap;
  // padding: 24px 0;

  li {
    width: 184px;
    margin-bottom: calc((766px - 184px*4) / 3);
  }
}
</style>
